import { Pagination, Spin, Tabs } from 'antd';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Axis,
  Chart,
  Coord,
  Geom,
  Guide,
  Label,
  Legend,
  Shape,
  Tooltip
} from 'bizcharts';
import { routerRedux } from 'dva/router';
import { View } from '@antv/data-set';
import moment from 'moment';
import { ENGLISH, PATH_HOME } from '../../utils/constants';
import en_us from 'rc-pagination/lib/locale/en_US';
import zh_cn from 'rc-pagination/lib/locale/zh_CN';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ userAbnormallyDetails, loading, intl, dispatch }) => {
    const {
      userSummary = {},
      cancelUserAbnormal = [],
      earlyEndUserAbnormal = [],
      extendUserAbnormal = [],
      normalUserAbnormal = [],
      pageTotals = 0,
      pageSize = 0,
      pageCurrent = 0
    } = userAbnormallyDetails;
    const {
      bookNum = 0,
      cancelNum = 0,
      earlyEndNum = 0,
      extendNum = 0,
      userDept = '',
      userName = ''
    } = userSummary;
    let normalNum = bookNum - (cancelNum + earlyEndNum + extendNum);

    const { Html } = Guide;
    const data = [
      {
        item: intl.formatMessage({ id: 'report_abnormal_normal_f' }),
        count: normalNum
      },
      {
        item: intl.formatMessage({ id: 'report_abnormal_cancel_f' }),
        count: cancelNum
      },
      {
        item: intl.formatMessage({ id: 'report_abnormal_extend_f' }),
        count: extendNum
      },
      {
        item: intl.formatMessage({ id: 'report_abnormal_early_end' }),
        count: earlyEndNum
      }
    ];
    const dv = new View();
    dv.source(data).transform({
      type: 'percent',
      field: 'count',
      dimension: 'item',
      as: 'percent'
    });
    const cols = {
      percent: {
        formatter: val => {
          val = Number(val * 100).toFixed(0) + '%';
          return val;
        }
      }
    };

    const clickTabs = (key, dispatch, intl) => {
      dispatch({
        type: 'userAbnormallyDetails/changeSelectTab',
        selectedKey: key
      });
    };

    const tableList = (data, key) => {
      let listData = [];
      for (let index = 0; index < 5; index++) {
        let item = index < data.length ? data[index] : {};
        let meetingTime =
          item.startDate && item.endDate
            ? moment(item.startDate).format('YYYY-MM-DD HH:mm') +
              ' - ' +
              moment(item.endDate).format('HH:mm')
            : '';
        if (4 == key) {
          listData.push(
            <li key={index}>
              <div className="reportTable">
                <div className="meeting-user-name-normal">
                  {item.meetingName}
                </div>
                <div className="meeting-user-time-normal">
                  {item.meetingTime}
                </div>
              </div>
            </li>
          );
        } else {
          listData.push(
            <li key={index}>
              <div className="reportTable">
                <div
                  className="meeting-user-name"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    paddingRight: '8%'
                  }}
                >
                  {item.meetingName}
                </div>
                <div className="meeting-user-time">{item.meetingTime}</div>
                <div className="operate-user-time">
                  {item.operateTime
                    ? moment(item.operateTime).format('YYYY-MM-DD HH:mm:ss')
                    : ''}
                </div>
              </div>
            </li>
          );
        }
      }
      return listData;
    };

    return (
      <div className="message-body roomDetail user-report-detail-container">
        <div className="messages-first roomDetailHeader">
          <div className="nav">
           {/* <a>
              <FormattedMessage id="report_abnormal_statis_report" />
              &nbsp;/&nbsp;
              <FormattedMessage id="report_abnormal_user_detail" />
            </a>*/}
          </div>
          <button
            onClick={() => {
              dispatch(
                routerRedux.push(
                  `${PATH_HOME}userAbnormallyReport?detail=true`
                )
              );
            }}
          >
            <FormattedMessage id="report_abnormal_back" />
          </button>
        </div>
        <Spin spinning={loading} size="large">
          <div
            className="messages-list"
          >
            <div className="roomDetailName">
              {userDept +
                ' ' +
                userName +
                ' ' +
                intl.formatMessage({ id: 'report_abnormal_detail_page' })}
            </div>
            <Chart
              height={400}
              data={dv}
              scale={cols}
              padding={[40, 100, 40, 80]}
              forceFit
            >
              <Coord type={'theta'} radius={0.75} innerRadius={0.6} />
              <Axis name="percent" />
              <Legend
                position="right"
                offsetY={-30}
                offsetX={-150}
                textStyle={{
                  fill: '#333', // 文本的颜色
                  fontSize: '12' // 文本大小
                }}
              />
              <Tooltip
                showTitle={false}
                itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
              />
              <Guide>
                <Html
                  position={['50%', '50%']}
                  html="<div style=&quot;display:none;color:#8c8c8c;font-size:1.16em;text-align: center;width: 10em;&quot;>主机<br><span style=&quot;color:#262626;font-size:2.5em&quot;>200</span>台</div>"
                  alignX="middle"
                  alignY="middle"
                />
              </Guide>
              <Geom
                type="intervalStack"
                position="percent"
                color={['item', ['#45C0DF', '#FFC851', '#FF7070', '#8080FF']]}
                tooltip={[
                  'item*percent',
                  (item, percent) => {
                    percent = Number(percent * 100).toFixed(0) + '%';
                    return {
                      name: item,
                      value: percent
                    };
                  }
                ]}
                style={{ lineWidth: 2, stroke: '#333' }}
              >
                <Label
                  content="percent"
                  offset="35"
                  textStyle={{
                    fill: '#333', // 文本的颜色
                    fontSize: '14', // 文本大小
                    textBaseline: 'middle' // 文本基准线，可取 top middle bottom，默认为middle
                  }}
                  formatter={(val, item) => {
                    return item.point.item + ': ' + val;
                  }}
                />
              </Geom>
            </Chart>
            <div className="report-abnormal-container">
              <Tabs
                type="card"
                onChange={key => {
                  clickTabs(key, dispatch, intl);
                }}
                defaultActiveKey="1"
                animated={false}
              >
                <Tabs.TabPane
                  tab={
                    <div
                      className="antd-tabs-div"
                      title={intl.formatMessage(
                        { id: 'report_abnormal_cancel_num' },
                        { num: cancelNum }
                      )}
                    >
                      <FormattedMessage
                        id="report_abnormal_cancel_num"
                        values={{ num: cancelNum }}
                      />
                    </div>
                  }
                  key="1"
                >
                  <div className="list-cont">
                    <div className="roomAbnormalReport">
                      <div className="reportTable header">
                        <div
                          className="meeting-user-name"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_name'
                          })}
                        </div>
                        <div className="meeting-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_time'
                          })}
                        </div>
                        <div className="operate-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_operate_time'
                          })}
                        </div>
                      </div>
                      <ul className="messages">
                        {tableList(cancelUserAbnormal, 1)}
                      </ul>
                    </div>
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <div
                      className="antd-tabs-div"
                      title={intl.formatMessage(
                        { id: 'report_abnormal_early_end_num' },
                        { num: earlyEndNum }
                      )}
                    >
                      <FormattedMessage
                        id="report_abnormal_early_end_num"
                        values={{ num: earlyEndNum }}
                      />
                    </div>
                  }
                  key="2"
                >
                  <div className="list-cont">
                    <div className="roomAbnormalReport">
                      <div className="reportTable header">
                        <div
                          className="meeting-user-name"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_name'
                          })}
                        </div>
                        <div className="meeting-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_time'
                          })}
                        </div>
                        <div className="operate-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_operate_time'
                          })}
                        </div>
                      </div>
                      <ul className="messages">
                        {tableList(earlyEndUserAbnormal, 2)}
                      </ul>
                    </div>
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <div
                      className="antd-tabs-div"
                      title={intl.formatMessage(
                        { id: 'report_abnormal_extend_num' },
                        { num: extendNum }
                      )}
                    >
                      <FormattedMessage
                        id="report_abnormal_extend_num"
                        values={{ num: extendNum }}
                      />
                    </div>
                  }
                  key="3"
                >
                  <div className="list-cont">
                    <div className="roomAbnormalReport">
                      <div className="reportTable header">
                        <div
                          className="meeting-user-name"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_name'
                          })}
                        </div>
                        <div className="meeting-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_time'
                          })}
                        </div>
                        <div className="operate-user-time">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_operate_time'
                          })}
                        </div>
                      </div>
                      <ul className="messages">
                        {tableList(extendUserAbnormal, 3)}
                      </ul>
                    </div>
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <div
                      className="antd-tabs-div"
                      title={intl.formatMessage(
                        { id: 'report_abnormal_normal_num' },
                        { num: normalNum }
                      )}
                    >
                      <FormattedMessage
                        id="report_abnormal_normal_num"
                        values={{ num: normalNum }}
                      />
                    </div>
                  }
                  key="4"
                >
                  <div className="list-cont">
                    <div className="roomAbnormalReport">
                      <div className="reportTable header">
                        <div
                          className="meeting-user-name-normal"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_name'
                          })}
                        </div>
                        <div className="meeting-user-time-normal">
                          {intl.formatMessage({
                            id: 'report_abnormal_detail_meeting_time'
                          })}
                        </div>
                      </div>
                      <ul className="messages">
                        {tableList(normalUserAbnormal, 4)}
                      </ul>
                    </div>
                  </div>
                </Tabs.TabPane>
              </Tabs>
              <div className="page-cont">
                {pageTotals == 0 ? null : (
                  <Pagination
                    size="small"
                    total={pageTotals}
                    pageSize={pageSize}
                    current={pageCurrent}
                    onChange={p => {
                      dispatch({
                        type: 'userAbnormallyDetails/changePage',
                        pageNo: p
                      });
                    }}
                    locale={
                      intl.formatMessage({ id: 'locale' }) === ENGLISH
                        ? en_us
                        : zh_cn
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </Spin>
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/components/report/UserReportAbnormallyDetail.js